import { addBookingOrder } from '@api/asset';
import { createOrder, createPriceBreakup, getOrders, retryOrder } from '@api/order';
import { handlePayment } from '@api/payment';
import { getUserDetailByPhone } from '@api/visitors';
import AddressPanel from '@components/address';
import { CartInfo } from '@components/cartinfo';
import {
  TAddon,
  TAddress,
  TComponent,
  TCreateOrder,
  TIdentity,
  TOrder,
  TOtp,
  TStore,
  TVisitor
} from '@components/types';
import { OrderItemWidget } from '@components/widget/orderitems';
import ScrollDownbtn from '@components/widget/scrollDownbtn';
import { getLocation } from '@core/geolocation';
import { getLength } from '@core/utils';
import { addressState, cartState, isLoggedIn, profileState } from '@recoil/atoms';
import { message as antdMessage, Input, Radio } from 'antd';
import { motion } from 'framer-motion';
import { getDistance } from 'geolib';
import Cookies from 'js-cookie';
import { ChevronLeft, CircleCheck, CircleX, Loader, X } from 'lucide-react';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { SPACartDetails } from './summary';
import OtpModal from '../otpmodal';
import { generateOtp, verifyWhatsappOtp } from '@api/verification';
import { getprofile } from '@api/authentication';

type Props = {
  setIsCartOpen?: Function;
  isCartOpen?: boolean;
  orders?: TOrder[];
  mode?: string;
  setIsMyOrdersOpen?: Function;
  noLink?: boolean;
  store?: TStore;
  maxWidth?: string;
  selectedBooking?: any;
  selectedRoom?: any;
};

const MyCart: React.FC<Props> = ({
  setIsCartOpen,
  isCartOpen,
  orders,
  mode,
  setIsMyOrdersOpen,
  noLink = false,
  store,
  maxWidth,
  selectedBooking,
  selectedRoom,
}) => {
  const [profile, setProfile] = useState<TIdentity>(null);
  const [isLogin, setIsLogin] = useRecoilState(isLoggedIn);
  const [visitorInfo, setVisitorInfo] = useState<TVisitor | null>(null);
  const [tableInfo, setTableInfo] = useState(null);
  const [dineinOrTakeaway, setDineinOrTakeaway] = useState(store?.storemeta?.settings?.dine_in ? "DINEIN" : "DELIVERY");
  const [isDelivery, setIsDelivery] = useState(false);
  const [cartStage, setCartStage] = useState('cart');
  const [paymentMethod, setPaymentMethod] = useState(store?.storemeta?.settings?.upi ? 'UPI' : store?.storemeta?.settings?.banking ? 'DC' : 'Cash');
  const [paymentBreakup, setPaymentBreakup] = useState(null);
  const [cart, setCart] = useRecoilState(cartState);
  const [orderInstructions, setOrderInstructions] = useState<any>({});
  const [userInfo, setUserInfo] = useState<TIdentity>(() => {
    if (typeof window === 'undefined') return null;
    const stored = JSON.parse(localStorage.getItem('profile') || 'null');
    // Only restore if it's a real authenticated profile with an id
    return stored?.id ? stored : null;
  });
  const [transactionId, setTransactionId] = useState<TOrder>();
  const tsxnId =
    typeof window !== 'undefined'
      ? localStorage.getItem('transaction_id')
      : null;
  const [orderDetails, setOrderDetails] = useState<TOrder[]>([]);
  const [orderDetail, setOrderDetail] = useState<TOrder>({});
  const cartValue = Array.from(useRecoilValue(cartState).values());
  const [isLoading, setIsLoading] = useState(false);
  const selectedAddress = useRecoilValue(addressState);
  const router = useRouter();
  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const scrollContainerRef = useRef(null);
  const [openOtpModal, setOpenOtpModal] = useState(false)
  const [otpId, setOtpId] = useState(0)
  const [otp, setOtp] = useState(0)
  const [user, setUser] = useRecoilState<TIdentity>(profileState);
  const [isOtpVerified, setIsOtpVerified] = useState(false)
  const [verifiedPhone, setVerifiedPhone] = useState('')

  const isOtpVerifiedRef = useRef(false);
  const verifiedPhoneRef = useRef('');

  // Wherever you set isOtpVerified, also update the ref
  const setOtpVerified = (val: boolean) => {
    isOtpVerifiedRef.current = val;
    setIsOtpVerified(val);
  };

  const setPhoneVerified = (value: string) => {
    verifiedPhoneRef.current = value;
    setVerifiedPhone(value);
  };

  const handlePhoneChange = (e: any) => {
    const value = e.target.value;
    // Ensure that the entered value consists of only numeric characters
    if (!/^\d*$/.test(value)) {
      return;
    } else {
      setPhone(value);
      setUserInfo({ phone: value });
      if (value !== verifiedPhoneRef.current) {
        setOtpVerified(false);
        setPhoneVerified('');
      }
    }
  };

  useEffect(() => {
    if (userInfo?.phone != undefined && userInfo?.phone?.length >= 10) {
      getUserDetailByPhone(userInfo?.phone).then((res) => {
        if (res) {
          // Only pre-fill the name for convenience — don't persist to localStorage
          setFullName(res?.full_name);
          // Keep phone but don't treat this as an authenticated profile
          setUserInfo(prev => ({ phone: prev?.phone, full_name: res?.full_name }));
        }
      })?.catch((err) => {
        console.log(err);
      })
    }
  }, [userInfo?.phone]);

  const onNonLoggedInUseProceed = () => {
    const isValidNumber = /^[0-9]+$/.test(phone);
    if (!isValidNumber) {
      setMessage('Please enter a valid phone number');
      return;
    }

    if (
      store?.storemeta?.settings?.otp_verify_online_order &&
      (!isOtpVerifiedRef.current || verifiedPhoneRef.current !== phone)
    ) {
      antdMessage.error('Please verify your phone number with OTP first.');
      return;
    }

    if (false && store?.storemeta?.settings?.otp_verify_online_order) {
      console.log(isOtpVerifiedRef.current)
      if (!isOtpVerifiedRef.current) {  // ← dual check
        antdMessage.error('Please verify your phone number with OTP first.');
        return;
      }
    }

    if (!visitorInfo) {
      const names = fullName.split(' ');
      setUserInfo({
        first_name: names?.length > 0 ? names[0] : '',
        last_name: names?.length > 1 ? names[1] : '',
        full_name: fullName,
        phone: phone,
      });
      // setCartStage("paymentmethod")
      if (dineinOrTakeaway == "DELIVERY") {
        setCartStage('selectaddress');
      } else {
        setCartStage('paymentmethod');
      }
    } else {
      setVisitorInfo({ ...visitorInfo, name: fullName, phone: phone });
      localStorage.setItem(
        'visitorInfo',
        JSON.stringify({ ...visitorInfo, name: fullName, phone: phone })
      );
      if (dineinOrTakeaway == "DELIVERY") {
        setCartStage('selectaddress');
      } else {
        setCartStage('paymentmethod');
      }
    }
  };

  useEffect(() => {
    if (localStorage.getItem('visitorInfo')) {
      const visitor: TVisitor = JSON.parse(localStorage.getItem('visitorInfo'));
      setFullName(visitor?.name);
      setPhone(visitor?.phone);
    }
  }, []);

  const onDineinOrTakeaway = (value: string) => {
    if (value === 'DELIVERY') {
      setIsDelivery(true);
    }
    setDineinOrTakeaway(value);
    sessionStorage.setItem(
      'tableInfo',
      JSON.stringify({
        source: tableInfo?.source,
        table: tableInfo?.table,
        table_id: tableInfo?.table_id,
        is_ac: tableInfo?.is_ac,
        dineinOrTakeaway: value,
        timeStamp: Date.now(),
      })
    );
  };

  async function onProceed() {
    const isAuthenticated = !!(
      typeof window !== 'undefined' && localStorage.getItem('profile')
        ? JSON.parse(localStorage.getItem('profile'))?.id  // logged-in user has an id
        : null
    );

    if (!isAuthenticated) {
      // Always force through nonloggedinuser stage if not truly authenticated
      setCartStage('nonloggedinuser');
      return;
    }

    if (isDelivery || dineinOrTakeaway === 'DELIVERY') {
      setCartStage('selectaddress');
    }
    else if (tableInfo || selectedRoom?.id > 0) {
      if (dineinOrTakeaway === 'DINEIN') {
        setCartStage('paymentmethod');
      } else if (dineinOrTakeaway === 'TAKEAWAY') {
        setCartStage('paymentmethod');
      }
    }

    else {
      if (store?.category_id == 1 && dineinOrTakeaway != "DELIVERY" && (selectedRoom?.id == null || selectedRoom?.id == undefined)) {
        const isPickupAvailable = await isOrderDeliverable();
        if (!isPickupAvailable) {
          antdMessage.error('Pickup is not available from your location.');
        } else {
          setCartStage('paymentmethod')
        }
      } else {
        setCartStage('paymentmethod')
      }
    };

  }

  useEffect(() => {
    console.log(tableInfo)
  }, [tableInfo])


  useEffect(() => {
    if (typeof window !== `undefined` && localStorage.getItem('profile')) {
      setProfile(JSON.parse(localStorage.getItem('profile')));
    }

    if (typeof window !== `undefined` && localStorage.getItem('visitorInfo')) {
      setVisitorInfo(JSON.parse(localStorage.getItem('visitorInfo')));
    }

    if (typeof window !== `undefined` && sessionStorage.getItem('tableInfo')) {
      setTableInfo(JSON.parse(sessionStorage.getItem('tableInfo')));
      setDineinOrTakeaway('DINEIN');
      setPaymentMethod('Cash');
    }
    if (selectedRoom?.id > 0) {
      setDineinOrTakeaway('DINEIN');
    }
    if (!isCartOpen) {
      setOtpVerified(false);
      setPhoneVerified('');
      setOtpId(0);
      setOtp(0);
      setCartStage('cart');
      setMessage("")
    }
  }, [isCartOpen]);

  useEffect(() => {
    if (tsxnId != undefined) {
      getOrders([], [], tsxnId).then((result: TOrder[]) => {
        setOrderDetails(result);
      });
    }
  }, [tsxnId]);

  useEffect(() => {
    if (tsxnId != undefined) {
      setTransactionId({ ...transactionId, transaction_id: tsxnId });
    }
  }, [tsxnId]);

  const repeatOrder = () => {
    if (paymentMethod == undefined || paymentMethod == null) {
      antdMessage.error('Please select a Payment method');
    }
    setIsLoading(true);
    retryOrder(transactionId).then((res) => {
      localStorage.setItem('transaction_id', res?.transaction?.id);
      if (
        typeof window !== 'undefined' &&
        typeof window.invokePayment === 'function'
      ) {
        let tableInfo = JSON.parse(sessionStorage.getItem('tableInfo'));
        if (paymentMethod == 'Cash' && tableInfo != undefined) {
          setCartStage('tablesuccess');
          localStorage.removeItem('tableInfo');
        }
        if (paymentMethod == 'Cash') {
          setCartStage('cashsuccess');
        } else {
          window.invokePayment(res);
        }
      }
    }).catch((err) => {
      antdMessage.error('Something went wrong!');
    })?.finally(() => {
      setIsLoading(false);
    });
  };

  const getPaymentBreakup = () => {
    let orderComponents: TComponent[] = [];
    Array.from(cart.values()).map((value) => {
      let addonComponent = Array();
      value?.addon?.map((addOn: TAddon) => {
        let addonObject = {
          inventory_id: addOn?.addon_id,
          price: addOn.price || addOn.addon?.price || 0,
          inventoryaddon_id: addOn?.id,
        };
        addonComponent?.push(addonObject);
      });
      orderComponents.push({
        quantity: value?.quantity,
        inventory_id: value?.inventory?.id,
        is_delivery: value?.deliverable && (tableInfo?.table_id == null || tableInfo?.table_id == undefined) && (selectedRoom?.id == null || selectedRoom?.id == undefined),
        add_ons: addonComponent,
      });
    });
    let currentOrder: TCreateOrder = {
      components: orderComponents,
      shipping_address_id: selectedAddress?.id,
      payment_mode: paymentMethod || "Cash",
      currency: 'INR',
      user: userInfo,
      info: {
        table: tableInfo?.table || '',
        table_id: tableInfo?.table_id || null,
        source: tableInfo?.table_id > 0 ? 'TABLE' : 'ONLINE',
        uid: Cookies.get('uid'),
        sid: Cookies.get('sid'),
        kind:
          tableInfo?.table_id > 0
            ? 'TABLE'
            : dineinOrTakeaway == "DELIVERY"
              ? 'delivery'
              : 'takeaway',
        gst: store?.storemeta?.functions?.gst_billing,
        template: store?.storemeta?.functions?.gst_billing
          ? store?.storemeta?.gst?.gst_template
          : store?.storemeta?.gst?.template,
      },
    };
    if (orderComponents?.length > 0) {
      createPriceBreakup(currentOrder)?.then((res) => {
        setPaymentBreakup(res);
      })?.catch((err) => antdMessage?.error("Something went wrong!"))
    }
  }

  const createNewOrder = async () => {
    let orderComponents: TComponent[] = [];
    Array.from(cart.values()).map((value) => {
      let addonComponent = Array();
      value?.addon?.map((addOn: TAddon) => {
        let addonObject = {
          inventory_id: addOn?.addon_id,
          price: addOn.price || addOn.addon?.price || 0,
          inventoryaddon_id: addOn?.id,
        };
        addonComponent?.push(addonObject);
      });
      orderComponents.push({
        quantity: value?.quantity,
        inventory_id: value?.inventory?.id,
        is_delivery: value?.deliverable && (tableInfo?.table_id == null || tableInfo?.table_id == undefined) && (selectedRoom?.id == null || selectedRoom?.id == undefined),
        add_ons: addonComponent,
      });
    });
    if (orderComponents.length !== 0 && typeof window !== 'undefined') {
      let tableInfo = JSON.parse(sessionStorage.getItem('tableInfo'));
      let currentOrder: TCreateOrder = {
        components: orderComponents,
        shipping_address_id: selectedAddress?.id,
        payment_mode: paymentMethod,
        currency: 'INR',
        user: userInfo,
        info: {
          instructions: orderInstructions?.instructions,
          delivery_date: store?.storemeta?.settings?.schedule_delivery ? orderInstructions?.delivery_date : null,
          table: tableInfo?.table || '',
          table_id: tableInfo?.table_id || null,
          source: tableInfo?.table_id > 0 ? 'TABLE' : (selectedRoom?.id > 0 ? 'ROOM-SERVICE' : 'ONLINE'),
          platform: "ONLINE",
          uid: Cookies.get('uid'),
          sid: Cookies.get('sid'),
          kind:
            tableInfo?.table_id > 0
              ? 'TABLE'
              : dineinOrTakeaway == "DELIVERY"
                ? 'delivery'
                : 'takeaway',
          gst: store?.storemeta?.functions?.gst_billing,
          template: store?.storemeta?.functions?.gst_billing
            ? store?.storemeta?.gst?.gst_template
            : store?.storemeta?.gst?.template,
        },
      };

      if (paymentMethod == undefined || paymentMethod == null) {
        antdMessage.error('Please select a payment method.');
        return;
      }
      if (store?.storemeta?.settings?.schedule_delivery && store?.storemeta?.settings?.delivery_date_mandatory && !orderInstructions?.delivery_date) {
        antdMessage.error('Please select a delivery time.');
        return;
      }
      setIsLoading(true);
      createOrder(currentOrder)
        .then((res) => {
          setOrderInstructions({})
          if (selectedRoom?.id > 0) {
            addBookingOrder({ order_id: res?.transaction?.orders?.length > 0 ? res?.transaction?.orders[0].id?.toString() : '', room_id: selectedRoom?.id?.toString(), room_name: selectedRoom?.name })?.then((res) => {
              antdMessage?.success("Order added to booking successfully");
            })?.catch((err) => {
              antdMessage?.error(err?.response?.data?.detail || "Error in adding order to booking");
            })
          }
          localStorage.setItem(
            'orderId',
            res?.transaction?.orders?.length > 0
              ? res?.transaction?.orders[0].id
              : ''
          );
          localStorage.setItem('transaction_id', res?.transaction?.id);
          setOrderDetail(res?.transaction?.orders[0]);
          setPaymentMethod(store?.storemeta?.settings?.upi ? "UPI" : "Cash");
          if (typeof window !== 'undefined') {
            if (paymentMethod == 'Cash' && tableInfo != undefined) {
              setCartStage('tablesuccess');
              localStorage.removeItem('tableInfo');
            } else if (paymentMethod == 'Cash') {
              setCartStage('tablesuccess');
            } else {
              const paymentResponse = handlePayment(
                res?.transaction?.id,
                `/shop/${res?.transaction?.orders[0]?.store?.id}?transaction_id=${res?.transaction?.id}&mode=status`
              );
              paymentResponse
                .then((response) => {
                  router.push(response.data.url);
                  setCart(new Map());
                })
                .catch((error) => {
                  console.debug(error);
                  antdMessage.error('Payment failed. Please try again.');
                  setCart(new Map());
                  setCartStage('paymentFailed');
                });
            }
          }
          if (paymentMethod == 'Cash') {
            setCart(new Map());
          }
        })
        .catch((error) => {
          setIsLoading(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  async function isOrderDeliverable(selectedAddress: TAddress = null): Promise<boolean> {
    const storeLatitude = store?.address?.latitude || store?.address?.city?.latitude
    const storeLongitude = store?.address?.longitude || store?.address?.city?.longitude

    // Store coords are required — can't compute distance without them
    if (!storeLatitude || !storeLongitude) return true

    let addressLatitude = selectedAddress?.latitude || selectedAddress?.city?.latitude
    let addressLongitude = selectedAddress?.longitude || selectedAddress?.city?.longitude

    // Only call getLocation if address has no coords
    if (!addressLatitude || !addressLongitude) {
      const location = await getLocation()
      addressLatitude = location?.latitude
      addressLongitude = location?.longitude
    }

    // If we still have no customer location, can't determine — allow delivery
    if (!addressLatitude || !addressLongitude) return true

    const distance = getDistance(
      { latitude: addressLatitude, longitude: addressLongitude },
      { latitude: storeLatitude, longitude: storeLongitude }
    )

    if (distance != null) {
      return parseFloat(((distance) / 1000).toFixed(1)) <= 10
    }

    return true
  }

  const onAddressProceed = async () => {
    if (!selectedAddress?.id) {
      antdMessage.error('Please create or select an address to proceed.')
      return
    }

    if (store?.category_id == 1) {
      // const deliverable = await isOrderDeliverable(selectedAddress);
      // if (deliverable) {
      setCartStage('paymentmethod');
      // } else {
      //   antdMessage.error('Order is not deliverable at this address, Please select another address under 10km.');
      // }
    }
    else if (selectedAddress?.id) {
      setCartStage('paymentmethod');
    } else {
      antdMessage.error('Please create or select an address to proceed.');
    }
  };

  const onEditInfoClick = () => {
    setCartStage('nonloggedinuser');
  };

  useEffect(() => {
    if (cart?.size > 0) {
      getPaymentBreakup()
    }
  }, [cart])

  useEffect(() => {
    if (isCartOpen) {
      // Lock scrolling when cart is open
      document.body.style.overflow = 'hidden';
    } else {
      // Restore scrolling when cart is closed
      document.body.style.overflow = 'unset';
    }

    // Cleanup function to ensure scroll is restored when component unmounts
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isCartOpen]);

  const verifyWithOtp = () => {
    const isValidNumber = /^[0-9]+$/.test(phone);
    if (!isValidNumber) {
      setMessage('Please enter a valid phone number');
      return;
    }
    const result = generateOtp({ key: phone, type: 'm' });
    result
      .then((res: TOtp) => {
        if (res?.success == true) {
          setMessage(res?.msg);
          setOtpId(res.otp_id);
          setOpenOtpModal(true);
        }
      })
      .catch((e) => {
        if (e.response?.status === 401) {
          setMessage("Something went wrong");
        }
      });
  };

  const verifyOtp = () => {
    const result = verifyWhatsappOtp(otpId, otp)
    result.then((res: any) => {
      if (res.access_token?.length > 0) {
        antdMessage.success("OTP Verified Successfully")
        localStorage.setItem('token', res.access_token)
        const res_profile: Promise<TIdentity> = getprofile()
        res_profile.then((profile) => {
          setUser(profile)
          setProfile(profile)
          setUserInfo(profile)
          setIsLogin(true)
          localStorage.setItem('profile', JSON.stringify(profile))
          setOtpVerified(true)   // ← set AFTER profile is ready
          setPhoneVerified(phone)
          setOpenOtpModal(false)
          onNonLoggedInUseProceed()
        })
      } else {
        antdMessage.error('Invalid OTP. Please try again.')  // ← handle bad OTP
      }
    }).catch(() => {
      antdMessage.error('OTP verification failed.')
    })
  }

  const isCurrentPhoneVerified = isOtpVerified && verifiedPhone === phone;

  return (
    <div
      className={`fixed ${isCartOpen ? 'bottom-0' : '-bottom-150'
        } w-full z-[90] flex flex-col justify-center ${isCartOpen
          ? 'translate-y-0 pointer-events-auto'
          : 'translate-y-full pointer-events-none'}`}
    >
      <motion.div
        className={`grid justify-items-stretch ${maxWidth?.length > 0 ? maxWidth : ""}`}
        animate={isCartOpen ? 'open' : 'closed'}
        variants={{
          open: { x: 0, y: '-64px' },
          closed: { y: '100%' },
        }}
        transition={{ ease: 'easeOut', duration: 0.5 }}
      >
        <div
          style={{ background: store?.storemeta?.settings?.shop_page_theme?.bg || "#0F6E56" }}
          className="relative flex flex-col gap-2 justify-start items-center w-full max-h-120 h-fit z-20 rounded-t-3xl pb-4 shadow-2xl">
          <div className="w-10 h-1 rounded-full bg-white/20 mt-2"></div>
          <div className="flex flex-row">
            <div style={{ color: store?.storemeta?.settings?.shop_page_theme?.text || "" }} className="pt-2 pb-2 font-manrope text-base text-neutral-50 font-semibold">
              My Cart
            </div>
            <button
              type="button"
              style={{ color: store?.storemeta?.settings?.shop_page_theme?.text || "" }}
              className="absolute top-3 right-4 text-neutral-300 p-1.5 rounded-full hover:bg-white/10 transition-colors cursor-pointer"
              onClick={(e) => {
                setIsCartOpen();
                setCartStage('cart');
                setOtpVerified(false)
              }}
            >
              <X size={20} />
            </button>
          </div>
          {(cart.size > 0 && tableInfo?.table_id > 0) && (
            <span style={{ color: store?.storemeta?.settings?.shop_page_theme?.text || "" }} className="text-neutral-50">Ordering from Table - {tableInfo?.table}</span>
          )}

          {selectedRoom?.source === "ROOM-SERVICE" && selectedRoom?.id > 0 && (
            <span style={{ color: store?.storemeta?.settings?.shop_page_theme?.text || "" }} className="text-neutral-50">Ordering from {selectedRoom?.name}</span>
          )}
          {cartStage === 'cart' && (
            <div ref={scrollContainerRef} className="flex flex-col w-full gap-2 overflow-y-auto small-scrollbar">
              {(cart.size > 0) && (
                <div className="px-4 pb-2 flex gap-2 items-center flex-wrap">
                  {store?.storemeta?.settings?.dine_in &&
                    <button
                      type="button"
                      onClick={() => onDineinOrTakeaway('DINEIN')}
                      className={`px-3 py-1.5 rounded-full text-xs font-semibold cursor-pointer transition-colors ${dineinOrTakeaway == 'DINEIN' ? 'bg-brand-500 text-white' : 'bg-white/10 text-neutral-100 hover:bg-white/20'}`}
                    >
                      DINE IN
                    </button>
                  }
                  {store?.storemeta?.settings?.takeaway &&
                    <button
                      type="button"
                      onClick={() => onDineinOrTakeaway('TAKEAWAY')}
                      className={`px-3 py-1.5 rounded-full text-xs font-semibold cursor-pointer transition-colors ${dineinOrTakeaway == 'TAKEAWAY' ? 'bg-brand-500 text-white' : 'bg-white/10 text-neutral-100 hover:bg-white/20'}`}
                    >
                      TAKEAWAY
                    </button>
                  }
                  {
                    ((tableInfo?.table === null || tableInfo?.table === undefined) && store?.storemeta?.settings?.delivery) && (
                      <button
                        type="button"
                        onClick={() => { setIsDelivery(true); onDineinOrTakeaway('DELIVERY'); }}
                        className={`px-3 py-1.5 rounded-full text-xs font-semibold cursor-pointer transition-colors ${dineinOrTakeaway == 'DELIVERY' ? 'bg-brand-500 text-white' : 'bg-white/10 text-neutral-100 hover:bg-white/20'}`}
                      >
                        DELIVERY
                      </button>
                    )
                  }
                </div>
              )}

              <div className="flex md:flex-row grow justify-between gap-4 flex-col px-4">
                <div className="flex flex-1 flex-col gap-4">
                  {(visitorInfo || profile) && !tableInfo && !selectedRoom && cart?.size > 0 && (
                    <div className="p-4 rounded-2xl border border-neutral-200/70 bg-white shadow-sm">
                      <div className="flex justify-between items-center">
                        <div className="space-y-1.5">
                          <span className="text-xs text-neutral-500 font-semibold uppercase tracking-wide">
                            {profile ? 'Deliver to' : 'Billing info'}
                          </span>
                          <p className="text-sm text-neutral-800">
                            <span className="text-neutral-500">Name: </span>
                            <span className="font-semibold">{profile?.full_name
                              ? profile?.full_name
                              : visitorInfo?.name}</span>
                          </p>
                          <p className="text-sm text-neutral-800">
                            <span className="text-neutral-500">Phone: </span>
                            <span className="font-semibold">{profile?.full_name
                              ? profile?.phone
                              : visitorInfo?.phone}</span>
                          </p>
                        </div>

                        <button
                          onClick={() => {
                            onEditInfoClick();
                          }}
                          type="button"
                          className="text-sm text-business-500 font-manrope font-bold cursor-pointer hover:underline"
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                  )}
                  <CartInfo px="md:px-0" noLink={noLink} store={store} setIsDelivery={setIsDelivery} maxWidth={maxWidth} room={selectedRoom} />
                  <ScrollDownbtn scrollContainerRef={scrollContainerRef} Trigger={cartStage} />
                  {cart?.size > 0 && (
                    <SPACartDetails
                      store={store}
                      actionFun={onProceed}
                      paymentBreakup={paymentBreakup}
                      isLoading={isLoading}
                      btnName="PROCEED TO BUY"
                      isShowTaxes={true}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          {cartStage === 'paymentmethod' && (
            <div ref={scrollContainerRef} className="flex flex-col w-full gap-2 overflow-y-scroll small-scrollbar">
              <div className="flex flex-row gap-1 items-center px-2">
                <button
                  className="p-1.5 rounded-full hover:bg-white/10 cursor-pointer transition-colors"
                  onClick={() => {
                    setCartStage('cart');
                  }}
                >
                  <ChevronLeft className="text-lg text-white" />
                </button>
                <h1 className="font-semibold md:text-lg text-white font-manrope text-base">
                  Select payment method
                </h1>
              </div>
              <div className="h-2"></div>
              <div className={`flex ${maxWidth?.length > 0 ? "flex-col" : "md:flex-row"} grow h-full justify-between gap-4 flex-col px-2 pb-10`}>
                <div className="flex flex-col gap-2 w-full">
                    {store?.storemeta?.settings?.banking &&
                      <button type="button" onClick={() => setPaymentMethod('DC')} className={`flex items-center gap-3 w-full text-left rounded-xl px-4 py-3 border-2 transition-colors cursor-pointer ${paymentMethod === 'DC' ? 'bg-white border-brand-500' : 'bg-white border-neutral-200 hover:border-brand-500/40'}`}>
                        <Radio value="DC" checked={paymentMethod === "DC"} onChange={(e) => setPaymentMethod(e.target.value)} />
                        <label htmlFor="paymentmethod" className="font-semibold text-sm text-neutral-800 cursor-pointer">Credit / Debit card</label>
                      </button>}
                    {store?.storemeta?.settings?.upi &&
                      <button type="button" onClick={() => setPaymentMethod('UPI')} className={`flex items-center gap-3 w-full text-left rounded-xl px-4 py-3 border-2 transition-colors cursor-pointer ${paymentMethod === 'UPI' ? 'bg-white border-brand-500' : 'bg-white border-neutral-200 hover:border-brand-500/40'}`}>
                        <Radio value="UPI" checked={paymentMethod === "UPI"} onChange={(e) => setPaymentMethod(e.target.value)} />
                        <label htmlFor="paymentmethod" className="font-semibold text-sm text-neutral-800 cursor-pointer">UPI</label>
                      </button>}
                    {store?.storemeta?.settings?.cod &&
                      <button type="button" onClick={() => setPaymentMethod('Cash')} className={`flex items-center gap-3 w-full text-left rounded-xl px-4 py-3 border-2 transition-colors cursor-pointer ${paymentMethod === 'Cash' ? 'bg-white border-brand-500' : 'bg-white border-neutral-200 hover:border-brand-500/40'}`}>
                        <Radio disabled={!store?.storemeta?.settings?.cod} value="Cash" checked={paymentMethod === "Cash"} onChange={(e) => setPaymentMethod(e.target.value)} />
                        <label htmlFor="paymentmethod" className="font-semibold text-sm text-neutral-800 cursor-pointer">{dineinOrTakeaway == "DELIVERY" ? "Pay on delivery" : "Cash on counter"}</label>
                      </button>}
                    {!store?.storemeta?.settings?.cod && !store?.storemeta?.settings?.banking && !store?.storemeta?.settings?.upi &&
                      <button type="button" onClick={() => setPaymentMethod('Cash')} className={`flex items-center gap-3 w-full text-left rounded-xl px-4 py-3 border-2 transition-colors cursor-pointer ${paymentMethod === 'Cash' ? 'bg-white border-brand-500' : 'bg-white border-neutral-200 hover:border-brand-500/40'}`}>
                        <Radio value="Cash" checked={paymentMethod === "Cash"} onChange={(e) => setPaymentMethod(e.target.value)} />
                        <label htmlFor="paymentmethod" className="font-semibold text-sm text-neutral-800 cursor-pointer">{dineinOrTakeaway == "DELIVERY" ? "Pay on delivery" : "Cash on counter"}</label>
                      </button>}
                </div>

                <SPACartDetails
                  isLoading={isLoading}
                  store={store}
                  paymentBreakup={paymentBreakup}
                  isHidden={false}
                  isShowTaxes={true}
                  btnName="PROCEED TO PAY"
                  actionFun={cart.size > 0 ? createNewOrder : repeatOrder}
                  orderDetails={orderDetails}
                  orderInstruction={orderInstructions}
                  setOrderInstruction={setOrderInstructions}
                />
              </div>
              <ScrollDownbtn scrollContainerRef={scrollContainerRef} Trigger={cartStage} />
            </div>
          )}
          {cartStage === 'tablesuccess' && (
            <div className="grow flex flex-col gap-6 font-manrope px-2 w-full">
              <div className="flex flex-col items-center w-full rounded-2xl bg-white shadow-sm p-6 gap-3 text-center">
                <div className="flex items-center justify-center w-14 h-14 rounded-full bg-success-100">
                  <CircleCheck size={30} className="text-success-500" />
                </div>
                <h2 className="text-lg font-bold text-neutral-900">
                  {orderDetail?.info?.table_id != undefined
                    ? 'Please pay at the counter'
                    : 'Your order has been placed'}
                </h2>
                <p className="text-sm text-neutral-500">
                  {`Your order for ${(orderDetail?.orderitems || [])[0]?.inventory?.product
                    ?.name
                    }${getLength(orderDetail?.orderitems) > 1 ? '+' : ''}${getLength(orderDetail?.orderitems) > 1
                      ? `${getLength(orderDetail?.orderitems) - 1} items`
                      : ''
                    } has been placed`}
                </p>
                <button
                  className="w-full bg-brand-500 text-neutral-50 px-8 py-3 text-sm font-bold font-manrope whitespace-nowrap rounded-xl shadow-sm hover:brightness-110 transition-all cursor-pointer"
                  onClick={() => {
                    setIsCartOpen();
                    setIsMyOrdersOpen();
                    setCartStage('cart');
                  }}
                >
                  VIEW ORDER
                </button>
              </div>
              <OrderItemWidget cartValues={cartValue} title="Order Items" />
            </div>
          )}

          {
            cartStage === 'paymentFailed' && (
              <div className="flex flex-col justify-center items-center grow gap-2 w-full overflow-y-scroll min-h-36 px-2">
                <div className="flex flex-col items-center w-full rounded-2xl bg-white shadow-sm p-6 gap-3 text-center">
                  <div className="flex items-center justify-center w-14 h-14 rounded-full bg-error-100">
                    <CircleX size={28} className="text-error-500" />
                  </div>
                  <h2 className="text-lg font-bold text-neutral-900">Payment failed</h2>
                  <div className="text-sm text-neutral-500">
                    Order transaction ID: #{tsxnId || 'N/A'}
                  </div>
                  <p className="text-sm text-neutral-500">
                    Please try again
                  </p>
                  <button disabled={isLoading} className="w-full bg-brand-500 text-neutral-50 px-8 py-3 text-sm font-bold font-manrope whitespace-nowrap rounded-xl shadow-sm hover:brightness-110 transition-all cursor-pointer disabled:opacity-60" onClick={() => { repeatOrder() }}>Retry</button>
                </div>
              </div>
            )
          }
          {cartStage === 'selectaddress' && (
            <div ref={scrollContainerRef} className="flex flex-col justify-between grow gap-2 w-full overflow-y-scroll small-scrollbar">
              <div className="w-full flex flex-col gap-2">
                <h1 className="font-semibold text-white font-manrope px-2 md:text-lg text-base">
                  Select delivery address
                </h1>
                <div className="flex flex-col gap-1 w-full">
                  <AddressPanel
                    storeAddress={{
                      state_id: store?.address?.state_id,
                      city_id: store?.address?.city_id,
                    }}
                    px="px-2"
                    isDone={() => { }}
                    store={store}
                  />
                </div>
              </div>
              <ScrollDownbtn scrollContainerRef={scrollContainerRef} Trigger={cartStage} />
              <div className="flex flex-col items-center gap-4 px-2">
                <SPACartDetails
                  store={store}
                  isHidden={true}
                  paymentBreakup={paymentBreakup}
                  actionFun={onAddressProceed}
                  btnName="PROCEED"
                  isShowTaxes={true}
                />
              </div>
            </div>
          )}
          {cartStage === 'nonloggedinuser' && (
            <div className="flex flex-col justify-between grow gap-2 w-full overflow-y-scroll small-scrollbar px-2">
              <div>
                <h1 style={{ color: store?.storemeta?.settings?.shop_page_theme?.text || "" }} className="font-bold text-xl text-white font-manrope px-2 lt-sm:px-4 lt-sm:text-base">
                  Enter details
                </h1>
              </div>
              <p style={{ color: store?.storemeta?.settings?.shop_page_theme?.text || "" }} className="hidden lt-sm:block text-base lt-sm:text-xs text-neutral-100 py-2 px-4">
                This information will be shown on the bill and for SMS.
              </p>
              <div className="h-2"></div>
              <div className={`flex ${maxWidth?.length > 0 ? "flex-col" : "flex-row"} lt-sm:grow h-full justify-between gap-4 lt-sm:flex-col`}>
                <div className="flex flex-col justify-center gap-4 rounded-2xl p-4 bg-white shadow-sm">
                  <div className="flex flex-col gap-1.5 font-manrope">
                    <label
                      htmlFor="mobilenumber"
                      className="text-sm text-neutral-600 font-semibold"
                    >
                      Mobile number
                    </label>
                    <Input
                      className="rounded-xl px-3 py-2 max-w-[300px] w-full border-neutral-200"
                      maxLength={10}
                      pattern={'[1-9]{1}[0-9]{9}'}
                      disabled={visitorInfo?.phone ? true : false}
                      value={visitorInfo?.phone ? visitorInfo?.phone : phone}
                      onChange={(event) => {
                        handlePhoneChange(event);
                      }}
                      type="tel"
                      autoComplete="tel"
                    />
                  </div>
                  <div className="flex flex-col gap-1.5 font-manrope">
                    <label
                      htmlFor="Name"
                      className="text-sm text-neutral-600 font-semibold"
                    >
                      Name
                    </label>
                    <Input
                      className="rounded-xl px-3 py-2 max-w-[300px] w-full border-neutral-200"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      autoComplete="given-name"
                    />
                  </div>
                  {message?.length > 0 && <div className="col-span-6">
                    <p className="text-error-500 font-semibold text-center text-sm">
                      {message}
                    </p>
                  </div>}
                  <p className="font-manrope text-xs text-neutral-500 pt-1">
                    This information will be used on the bill generated by the
                    transaction and it will be sent to the mobile number through
                    SMS.
                  </p>
                </div>
                {
                  store?.storemeta?.settings?.otp_verify_online_order && !isCurrentPhoneVerified ?
                    <button
                      onClick={() => { verifyWithOtp() }}
                      className={`flex items-center justify-center gap-2 bg-brand-500 shadow-sm font-semibold text-sm text-neutral-50 px-1 md:px-2 py-3 rounded-xl w-full font-manrope disabled:opacity-60 cursor-pointer hover:brightness-110 transition-all`}
                    >
                      {isLoading && <Loader color='#fff' className="w-5 h-5 text-brand-500 animate-spin" />}
                      <span>Verify with OTP</span>
                    </button>
                    :
                    <SPACartDetails
                      actionFun={onNonLoggedInUseProceed}
                      btnName="PROCEED"
                      paymentBreakup={paymentBreakup}
                      isHidden={true}
                      isLoading={isLoading}
                      isShowTaxes={true}
                      store={store}
                    />
                }
              </div>
            </div>
          )}
        </div>
      </motion.div>
      <OtpModal
        showModal={openOtpModal}
        setShowModal={setOpenOtpModal}
        ActionFun={() => { verifyOtp() }}
        closeFunction={() => {
          setOpenOtpModal(false);
          setMessage("");  // ← add this
          setOtpId(0);
          setOtp(0);
        }}
        otp={otp}
        setOtp={setOtp}
        retryfunction={() => { verifyWithOtp() }}
        phone={phone}
        message={message}
      />
    </div>
  );
};

export default MyCart;
